function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function normalizeTemperatureInput(value: number): number {
  return clamp(value, 0, 100) / 100;
}

export function getTemperatureEstimate(temperature: number): {
  label: string;
  description: string;
  example: string;
} {
  const normalized = clamp(temperature, 0, 1.5);

  if (normalized < 0.25) {
    return {
      label: 'Deterministic',
      description: 'Stable and direct phrasing. Best for consistent support responses.',
      example: '“Customer asked for billing status. Next action: verify invoice and confirm ETA.”',
    };
  }

  if (normalized < 0.65) {
    return {
      label: 'Balanced',
      description: 'Good default: concise while preserving context and nuance.',
      example:
        '“Customer reported delayed billing confirmation and requested a same-day callback.”',
    };
  }

  return {
    label: 'Creative / Varied',
    description: 'More variation in wording, useful for exploratory drafts but less predictable.',
    example: '“Customer is anxious about billing delay and expects a concrete ownership update.”',
  };
}

export function getMaxTokensEstimate(maxTokens: number): {
  label: string;
  description: string;
} {
  const tokens = Math.round(clamp(maxTokens, 100, 4000));
  const words = Math.round(tokens * 0.75);

  if (words < 180) {
    return {
      label: `Approx up to ~${words} words`,
      description: 'Short output, low latency. May truncate action items on long conversations.',
    };
  }

  if (words < 420) {
    return {
      label: `Approx up to ~${words} words`,
      description: 'Balanced detail and latency. Good default for summary + highlights + actions.',
    };
  }

  return {
    label: `Approx up to ~${words} words`,
    description: 'Long output with richer detail, but higher latency and token usage.',
  };
}
